/* eslint-disable react-hooks/exhaustive-deps */
// -- == //
import { useEffect } from 'react';

import { useActions } from 'common/hooks/useActions';
import TextInput from 'components/form/textInput';
import UploadIcon from 'components/form/uploadIcon';
import TextArea from 'components/form/texArea';
import FieldPair from 'components/form/fieldPair';
import PanelBoxLayout from 'components/layout/panelBox';
import AddDivider from 'components/addDivider';
import RowAction from 'components/rowAction';
import Empty from 'components/empty';
import { toast } from 'common/helpers/toastConfig';

import * as S from './styles';
import * as T from 'common/types';

interface IProps {
  setValues: any;
  values: any;
}

const TrashIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14" />
  </svg>
);

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const PeopleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="8" r="3" />
    <path d="M3 20a6 6 0 0 1 12 0" />
    <path d="M19 8v6M22 11h-6" />
  </svg>
);

const LinkIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" />
    <path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M8 10v7M8 7v.01M12 17v-4a2 2 0 0 1 4 0v4" />
  </svg>
);

/** `01`, `02` — the design's `.repeat-n`. */
const ordinal = (index: number) => String(index + 1).padStart(2, '0');

/*
 * The event's speakers, as the design's repeatable item.
 *
 * It was a bordered list with a 15px radius whose rows held 31px inputs at
 * 11px on `#f7f8fc` grounds, a 30px `#ffeaea` delete circle, a `#34bea526`
 * add circle in the head, and a `#59b48d` focus ring written `!important`
 * over every input and textarea in the subtree. None of those colours are in
 * the palette and none of those sizes are on the scale.
 */
export default function EventFormGuestsList({ setValues, values }: IProps) {
  const { departmentsRequestAction, eventUploadGuestRequestAction } = useActions();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    departmentsRequestAction();
  };

  const handleAddNew = () => {
    let flag = 0;
    let flagLinkdin = 0;
    let flagWeblink = 0;

    const expression =
      // eslint-disable-next-line no-useless-escape
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
    const regex = new RegExp(expression);

    // eslint-disable-next-line array-callback-return
    values.guestsList.map((item: any) => {
      if (!item.fullName || !item.jobTitle || !item.description) {
        flag += 1;
      }
      if (!item.weblink.match(regex) && item.weblink) {
        flagWeblink += 1;
      }
      if (!item.linkedin.match(regex) && item.linkedin) {
        flagLinkdin += 1;
      }
    });
    if (flagWeblink > 0) {
      toast({
        message: `The website link format is wrong`,
        model: 'error'
      });
      return;
    }
    if (flagLinkdin > 0) {
      toast({
        message: `The linkedin link format is wrong`,
        model: 'error'
      });
      return;
    }
    if (flag !== 0) {
      toast({
        model: 'error',
        message: 'Full name, job title, Description fields are required'
      });
      return;
    }
    setValues({
      ...values,
      guestsList: [
        ...values.guestsList,
        {
          fullName: '',
          jobTitle: '',
          description: '',
          weblink: '',
          linkedin: '',
          avatar: '',
          image: '',
          id: JSON.stringify(Math.random() * 67)
        }
      ]
    });
  };

  const handleEdit = (value: string, key: string, guest: T.Pages.GuestListItem) => {
    setValues({
      ...values,
      guestsList: values.guestsList.map((item: T.Pages.GuestListItem) => {
        return item.id === guest.id
          ? {
              ...item,
              [key]: value
            }
          : item;
      })
    });
  };

  const handleDelete = (guest: T.Pages.GuestListItem) => {
    setValues({
      ...values,
      guestsList: values.guestsList.filter((item: T.Pages.GuestListItem) => item.id !== guest.id)
    });
  };

  return (
    <PanelBoxLayout title="Speakers" hint={values.guestsList.length ? `${values.guestsList.length} added` : 'Optional'}>
      <S.Stack>
        {values.guestsList.length ? (
          values.guestsList.map((item: T.Pages.GuestListItem, index: number) => (
            <S.RepeatItem key={item.id}>
              <S.RepeatHead>
                <S.RepeatN>{ordinal(index)}</S.RepeatN>
                <S.RepeatTitle>{item.fullName || 'New speaker'}</S.RepeatTitle>
                <S.RepeatActions>
                  <RowAction label={`Remove speaker ${ordinal(index)}`} onClick={() => handleDelete(item)}>
                    <TrashIcon />
                  </RowAction>
                </S.RepeatActions>
              </S.RepeatHead>

              <S.Body>
                <S.Portrait>
                  <UploadIcon
                    value={{
                      dataURL: item.image as string,
                      file: item.file
                    }}
                    onChange={(e: T.Form.FileUpload) => {
                      eventUploadGuestRequestAction({ image: e?.file }, (fileNameOnly: string) => {
                        setValues({
                          ...values,
                          guestsList: values.guestsList.map((item2: T.Pages.GuestListItem) => {
                            return item2.id === item.id
                              ? {
                                  ...item2,
                                  avatar: fileNameOnly,
                                  image: e.dataURL,
                                  file: e.file as any
                                }
                              : item2;
                          })
                        });
                      });
                    }}
                  />
                </S.Portrait>

                <S.Fields>
                  {/*
                   * These three are checked on submit and the check names
                   * them, so they carry the asterisk — the rule the rest of
                   * the product follows. Every one of them used to be a bare
                   * placeholder with no label at all.
                   */}
                  <FieldPair>
                    <TextInput
                      label="Full name"
                      required
                      value={item.fullName}
                      onChange={(e) => handleEdit(e.target.value, 'fullName', item)}
                      placeholder="Who is speaking?"
                    />
                    <TextInput
                      label="Job title"
                      required
                      value={item.jobTitle}
                      onChange={(e) => handleEdit(e.target.value, 'jobTitle', item)}
                      placeholder="What do they do?"
                    />
                  </FieldPair>

                  <TextArea
                    label="Description"
                    required
                    onChange={(e) => handleEdit(e.target.value, 'description', item)}
                    value={item.description}
                    placeholder="A line or two about them"
                  />

                  <FieldPair>
                    {/*
                     * Both of these are validated as full URLs on submit —
                     * `https://…` — but were labelled "Instagram ID" and
                     * "LinkedIn ID", which asks for a handle. The one with
                     * the Instagram glyph is `weblink`, so it was also the
                     * wrong network.
                     */}
                    <TextInput
                      label="Website"
                      onChange={(e) => handleEdit(e.target.value, 'weblink', item)}
                      value={item.weblink}
                      placeholder="https://example.com"
                      icon={<LinkIcon />}
                    />
                    <TextInput
                      label="LinkedIn"
                      onChange={(e) => handleEdit(e.target.value, 'linkedin', item)}
                      value={item.linkedin}
                      placeholder="https://linkedin.com/in/…"
                      icon={<LinkedInIcon />}
                    />
                  </FieldPair>
                </S.Fields>
              </S.Body>
            </S.RepeatItem>
          ))
        ) : (
          <Empty
            size="sm"
            icon={<PeopleIcon />}
            title="No speakers yet"
            text="Add the people presenting, so employees know who they are signing up to hear."
          />
        )}

        <AddDivider>
          <button type="button" onClick={handleAddNew}>
            <PlusIcon />
            Add speaker
          </button>
        </AddDivider>
      </S.Stack>
    </PanelBoxLayout>
  );
}
